<div class="app-container">
  <div
    class="navbar fixed-top bg-white p-4 shadow"
    *ngIf="fullyLoggedIn() && !blankPage"
  >
    <div class="d-flex justify-content-between w-100">
      <a class="d-flex align-items-center">
        <div class="pr-4 mr-4 border-right hamburger-menu">
          <i
            class="bars icon side-menu-icon pointer"
            id="hamburger"
            (click)="toggleSideMenu()"
          ></i>
        </div>
        <div class="">
          <img
            src="assets/images/qb_logo_black.svg"
            id="quickboard_logo"
            class="pointer"
            routerLink="/"
            width="136"
            height="30"
          />
        </div>
      </a>

      <div class="d-flex align-items-center">
        <div class="no-outline" [matMenuTriggerFor]="menu">
          <div class="d-inline-block pointer account-text">
            {{ name }}
            <i
              class="angle down icon flex large-text grayish"
              style="float: right; margin-left: 5px"
            ></i>
          </div>
          <div class="subtext location-text">
            Location: {{ currentLocation }}
          </div>

          <mat-menu #menu="matMenu">
            <div
              *ngIf="isPaymentAdmin()"
              class="menu-item pointer d-block pt-3 pb-3 pr-5 pl-5 border-bottom text-center"
              routerLink="/settings"
            >
              <span>My Account</span>
            </div>

            <div
              class="menu-item pointer d-block pt-3 pb-3 pr-5 pl-5 border-bottom text-center"
              *ngIf="!isPaymentAdmin() && fullyLoggedIn()"
              (click)="changeInfo()"
            >
              <span>Change account information</span>
            </div>

            <div
              class="menu-item pointer d-block pt-3 pb-3 pr-5 pl-5 border-bottom text-center"
              *ngIf="!isPaymentAdmin() && fullyLoggedIn()"
              (click)="openPasswordModal()"
            >
              <span>Change password</span>
            </div>

            <div
              class="menu-item pointer d-block pt-3 pb-3 pr-5 pl-5 border-bottom text-center"
              *ngIf="!isPaymentAdmin() && fullyLoggedIn()"
            >
              <span (click)="fileInput.click()" class="btn">Upload Photo</span>
              <i class="camera icon"></i>
              <span class="image-upload">
                <input
                  type="file"
                  #fileInput
                  name="file"
                  (ngModel)="(profilePicture)"
                  ng2FileSelect
                  [uploader]="imageUploader"
                  (click)="
                    image = null;
                    imagePreviewUrl = null;
                    imageUploader.clearQueue()
                  "
                  accept="image/*"
                />
              </span>
            </div>

            <div
              *ngIf="isPaymentAdmin() && hasMultipleLocations"
              class="menu-item pointer d-block pt-3 pb-3 pr-5 pl-5 border-bottom text-center"
              routerLink="/locations"
            >
              <span>Switch Locations</span>
            </div>

            <div
              class="menu-item pointer d-block pt-3 pb-3 pr-5 pl-5 text-center"
              (click)="logout()"
            >
              <span>Logout</span>
            </div>
          </mat-menu>
        </div>

        <img
          class="rounded-circle mr-2 border border-light"
          *ngIf="isPaymentAdmin()"
          routerLink="/settings"
          src="{{ profilePicture || 'assets/images/no_avatar.png' }}"
          width="40"
          height="40"
        />
        <img
          class="rounded-circle mr-2 border border-light"
          *ngIf="
            !isPaymentAdmin() && fullyLoggedIn() && imagePreviewUrl == null
          "
          src="{{ profilePicture || 'assets/images/no_avatar.png' }}"
          width="40"
          height="40"
        />

        <img
          class="rounded-circle mr-2 border border-light"
          *ngIf="
            !isPaymentAdmin() && fullyLoggedIn() && imagePreviewUrl != null
          "
          [src]="imagePreviewUrl"
          width="40"
          height="40"
        />
      </div>
    </div>
  </div>

  <div class="main">
    <div
      id="nav_menu"
      class="left-menu d-flex flex-column shadow"
      *ngIf="fullyLoggedIn() && !blankPage"
      [class]="{ displayed: sideMenuExpanded }"
    >
      <a
        class="left-menu-item uppercase p-3 align-items-center border-top d-flex"
        [routerLinkActive]="['current-page']"
        routerLink="/"
        [routerLinkActiveOptions]="{ exact: true }"
        [title]="sideMenuExpanded ? '' : 'Dashboard'"
      >
        <i class="material-icons">home</i>
        <p class="ml-3 align-items-center">Dashboard</p>
      </a>

      <!--<a
        class="left-menu-item uppercase p-3 align-items-center border-top d-flex"
        [routerLinkActive]="['current-page']"
        routerLink="/`results`">
        <i class="material-icons">insert_chart</i>
        <p class="ml-3 align-items-center">Results</p>
      </a>-->

      <span
        class="disabled-custom left-menu-item uppercase p-3 align-items-center border-top d-flex"
        [title]="sideMenuExpanded ? '' : 'Results'"
      >
        <i class="material-icons">insert_chart</i>
        <p class="ml-3 align-items-center">Results</p>
      </span>

      <a
        class="left-menu-item uppercase p-3 align-items-center border-top d-flex"
        [routerLinkActive]="['current-page']"
        routerLink="/{{_pt('sidebar_athletes_link')}}"
        [title]="sideMenuExpanded ? '' : _pt('sidebar_athletes')"
      >
        <i class="material-icons">group</i>
        <p class="ml-3 align-items-center">
          {{_pt('sidebar_athletes')}}
        </p>
      </a>

        <a
        class="left-menu-item uppercase p-3 align-items-center border-top d-flex"
        [routerLinkActive]="['current-page']"
        routerLink="/exercises"
        [title]="sideMenuExpanded ? '' : 'Exercises'"
      >
        <i class="material-icons">timer</i>
        <p class="ml-3 align-items-center">Exercises</p>
      </a>

<!--      <span
        class="disabled-custom left-menu-item uppercase p-3 align-items-center border-top d-flex"
        [title]="sideMenuExpanded ? '' : 'Exercises'"
      >
        <i class="material-icons">timer</i>
        <p class="ml-3 align-items-center">Exercises</p>
      </span>-->

      <!--<a
          class="left-menu-item uppercase p-3 align-items-center border-top d-flex"
          [routerLinkActive]="['current-page']"
          routerLink="/playlists">
          <i class="material-icons">playlist_play</i>
          <p class="ml-3 align-items-center">Playlists</p>
        </a>-->

      <span
        class="disabled-custom left-menu-item uppercase p-3 align-items-center border-top d-flex"
        [title]="sideMenuExpanded ? '' : 'Playlists'"
      >
        <i class="material-icons">playlist_play</i>
        <p class="ml-3 align-items-center">Playlists</p>
      </span>

      <a
        class="left-menu-item uppercase p-3 align-items-center border-top d-flex"
        [routerLinkActive]="['current-page']"
        routerLink="{{_pt('sidebar_workouts_link')}}"
        [title]="sideMenuExpanded ? '' : _pt('sidebar_workouts')">
        <i class="material-icons">assignment</i>
        <p class="ml-3 align-items-center">{{_pt('sidebar_workouts')}}</p>
      </a>
<!--
      <span
        class="disabled-custom left-menu-item uppercase p-3 align-items-center border-top d-flex"
      >
        <i class="material-icons">assignment</i>
        <p class="ml-3 align-items-center">
          {{_pt('sidebar_workouts')}}
        </p>
      </span>-->

      <!-- todo -> add a special type of permission for this section -->
      <!-- <a
        class="left-menu-item uppercase p-3 align-items-center border-top d-flex"
        [routerLinkActive]="['current-page']"
        routerLink="/overview">
        <i class="material-icons">map</i>
        <p class="ml-3 align-items-center">Overview</p>
      </a>-->

      <span
        class="disabled-custom left-menu-item uppercase p-3 align-items-center border-top d-flex"
        [title]="sideMenuExpanded ? '' : 'Overview'"
      >
        <i class="material-icons">map</i>
        <p class="ml-3 align-items-center">Overview</p>
      </span>

        <a
                class="left-menu-item uppercase p-3 align-items-center border-top d-flex"
                [routerLinkActive]="['current-page']"
                routerLink="/sports"
                *ngIf="isSuperAdmin()"
                [title]="sideMenuExpanded ? '' : 'Sports'"
        >
            <i class="material-icons">sports_baseball</i>
            <p class="ml-3 align-items-center">
                Sports
            </p>
        </a>

        <a
                class="left-menu-item uppercase p-3 align-items-center border-top d-flex"
                [routerLinkActive]="['current-page']"
                routerLink="/injuries"
                *ngIf="isSuperAdmin()"
                [title]="sideMenuExpanded ? '' : 'Injuries'"
        >
            <i class="material-icons">personal_injury</i>
            <p class="ml-3 align-items-center">
                Injuries
            </p>
        </a>

        <a
                class="left-menu-item uppercase p-3 align-items-center border-top d-flex"
                [routerLinkActive]="['current-page']"
                routerLink="/customs"
                *ngIf="isSuperAdmin()"
                [title]="sideMenuExpanded ? '' : 'Customs'"
        >
            <i class="material-icons">build</i>
            <p class="ml-3 align-items-center">
                Customs
            </p>
        </a>

      <button
        type="button"
        class="left-menu-item left-menu-toggle uppercase p-3 align-items-center border-top d-flex mt-auto"
        (click)="toggleSideMenu()"
        [title]="sideMenuExpanded ? 'Collapse menu' : 'Expand menu'"
      >
        <i class="material-icons">{{
          sideMenuExpanded ? "chevron_left" : "chevron_right"
        }}</i>
        <p class="ml-3 align-items-center">Collapse</p>
      </button>
    </div>

    <div
      class="nav-integration positive-relative"
      [class]="fullyLoggedIn() && !blankPage ? 'content' : 'notLogged'"
    >
      <div [class]="{ displayed: sideMenuExpanded }">
        <ng-container *ngIf="paymentData === undefined">
          <router-outlet></router-outlet>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<app-push-progress-host
  kind="Exercise"
  [slot]="0"
  *ngIf="fullyLoggedIn() && isSuperAdmin() && !blankPage">
</app-push-progress-host>
<app-push-progress-host
  kind="Workout"
  [slot]="1"
  *ngIf="fullyLoggedIn() && isSuperAdmin() && !blankPage">
</app-push-progress-host>
<div class="absolute top-0 left-0 w-full h-full bg-[#000000aa] flex justify-center items-center z-50" *ngIf="isSubscriptionInactive">
    <p class="text-lg text-white">Your subscription is inactive. To activate your subscription you need to <a routerLink="update-payment-info" class="text-underline text-blue-400">Click here.</a></p>
</div>
